import React from 'react';

export default class ShareYourStory extends React.PureComponent {
  render() {
    return (
      <footer className="share-your-story">
        <div className="inner">
          <div className="column-1">
            <p>Call for Submissions</p>
            <p>Share Your Story</p>
            <p>
              Give InKind offers a platform for anyone to submit their stories, to help and inspire others to get
              through any of life’s disruptions.
            </p>
          </div>
          <div className="column-2">
            <a href="https://create.giveinkind.com/call-for-submissions/" target="_blank" rel="noreferrer">
              <div className="submit">
                <p>SUBMIT YOUR WRITING</p>
              </div>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}
